export const LEAGUE_OPTIONS = [
    {
        value: "1OU5304zvw151RitjYjcjvIWyTHVAg6p7G8RNlbEKnZY",
        label: "GT3X",
    },
    {
        value: "1SEIDnbr6YjyJRWMME9QwdsdjBhY4IR0sHjCLw0l0tm0",
        label: "RaceVision Test",
    },
];